import { saveExternalLead } from "./core/save-external-lead";
export {
  saveExternalLead,
}

